import { useSelector } from 'react-redux'
import { Button, Form, Input } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAt } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import FormItem from '../../Components/shared/Forms/FormItem'

const PortalRequesterForm = ({
  email,
  emailLabel,
  hasEmailError = false,
  helpLabel,
  institutionName = '',
  loading = false,
  title,
  onEmailChange,
  onHasAccount,
  onSubmit
}) => {
  const t = useSelector(selectTranslate)

  return (
    <Form className='portal-requester' onSubmitCapture={onSubmit}>
      {institutionName.length !== 0 && (
        <div className='eyebrow'>{institutionName}</div>
      )}

      <h1 className='title'>{t(title)}</h1>

      <FormItem
        label={emailLabel}
        required
      >
        <Input
          size='large'
          prefix={<FontAwesomeIcon icon={faAt} style={{ color: 'rgba(0,0,0,.25)' }} />}
          className={hasEmailError ? 'error-ant-border' : ''}
          value={email}
          onChange={onEmailChange}
        />

        <div className='help'>{t(helpLabel)}</div>
      </FormItem>

      <Button
        className='logo-colored-button blue blue-ghost-hover w-100'
        size='large'
        type='primary'
        loading={loading}
        onClick={onSubmit}
      >
        {t('common.continue')}
      </Button>

      <div className='already-registered'>
        <span>{t('internship_request_portal.redirect.call_to_action')}</span>
        <Button type='link' onClick={onHasAccount}>
          {t('internship_request_portal.redirect.button')}
        </Button>
      </div>
    </Form>
  )
}

export default PortalRequesterForm
